import TextEm from "./TextEm"
import TextSmall from "./TextSmall"
import TextBody from "./TextBody"
import Heading1 from "./Heading1"
import Heading2 from "./Heading2"
import Heading3 from "./Heading3"
import Heading4 from "./Heading4"
import Paragraph from "./Paragraph"

export {
  TextEm,
  TextSmall,
  TextBody,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Paragraph,
}
